import calcFontSize from "./responsive_layout.js";

export default function init() {
  // 响应式布局设置
  calcFontSize();
  window.addEventListener("resize", calcFontSize);
}



// WEBPACK FOOTER //
// ./src/js/init.js